// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gDcR","label":"styles_label__h6-al"};